<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HMnnRy/tc-custom/9781398437623.jpg?1705540687395" alt="This image is the cover for the book Time for Tales"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Time for Tales
      </h1>
      <p class="bookDescription body article font2">
        <p>A book for children of short stories and poems for fun. Where two small mice have an adventure. When a giraffe worries about her long neck. There is magic one cold and frosty night. When strangest new friends are made. There is an amazing broom cupboard. A silver spoon that gets into a fight, a very noisy clock, and a puzzling far away sun.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean Oldbury
      </h2>
      
      <p class="authorDescription body article">Jean Oldbury lives in High Peak, Derbyshire, with her husband, David. She is a qualified nurse and midwife and has worked both at home and abroad during her nursing career. Now retired, she has always enjoyed reading and writing and can still remember, from when she was young, the wonder and magic of children's stories and fairy tales.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ca25e618